import { render, staticRenderFns } from "./BaseNumberInputElement.vue?vue&type=template&id=427035ef&scoped=true&"
import script from "./BaseNumberInputElement.vue?vue&type=script&lang=ts&"
export * from "./BaseNumberInputElement.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNumberInputElement.vue?vue&type=style&index=0&id=427035ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427035ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('427035ef')) {
      api.createRecord('427035ef', component.options)
    } else {
      api.reload('427035ef', component.options)
    }
    module.hot.accept("./BaseNumberInputElement.vue?vue&type=template&id=427035ef&scoped=true&", function () {
      api.rerender('427035ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/form/numberinput/BaseNumberInputElement.vue"
export default component.exports